document.addEventListener("DOMContentLoaded", function() {
    var readMoreBtn = document.getElementById("read-more");
    var productDescription = document.getElementById("product-description");

    function checkOverflow() {
        // Check if the content is overflowing
        if (productDescription.scrollHeight > productDescription.clientHeight) {
            readMoreBtn.style.display = "block";
        } else {
            readMoreBtn.style.display = "none";
        }
    }

    // Initial check
    checkOverflow();

    readMoreBtn.addEventListener("click", function() {
        if (productDescription.classList.contains("expanded")) {
            productDescription.classList.remove("expanded");
            readMoreBtn.textContent = "Read More";
        } else {
            productDescription.classList.add("expanded");
            readMoreBtn.textContent = "Read Less";
        }
    });

    // Re-check for overflow when the window is resized
    window.addEventListener("resize", checkOverflow);
});
